var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatePickerSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5.75H20.75M3.25 0.75H18.25C18.913 0.75 19.5489 1.01339 20.0178 1.48223C20.4866 1.95107 20.75 2.58696 20.75 3.25V18.25C20.75 18.913 20.4866 19.5489 20.0178 20.0178C19.5489 20.4866 18.913 20.75 18.25 20.75H3.25C2.58696 20.75 1.95107 20.4866 1.48223 20.0178C1.01339 19.5489 0.75 18.913 0.75 18.25V3.25C0.75 2.58696 1.01339 1.95107 1.48223 1.48223C1.95107 1.01339 2.58696 0.75 3.25 0.75Z",
    stroke: "#3D3B3B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97466 12.8058C5.98865 12.8058 6.81065 11.9838 6.81065 10.9698C6.81065 9.95579 5.98865 9.13379 4.97466 9.13379C3.96067 9.13379 3.13867 9.95579 3.13867 10.9698C3.13867 11.9838 3.96067 12.8058 4.97466 12.8058Z",
    fill: "#3D3B3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7305 12.8058C11.7445 12.8058 12.5665 11.9838 12.5665 10.9698C12.5665 9.95579 11.7445 9.13379 10.7305 9.13379C9.71653 9.13379 8.89453 9.95579 8.89453 10.9698C8.89453 11.9838 9.71653 12.8058 10.7305 12.8058Z",
    fill: "#3D3B3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4864 12.8058C17.5004 12.8058 18.3224 11.9838 18.3224 10.9698C18.3224 9.95579 17.5004 9.13379 16.4864 9.13379C15.4724 9.13379 14.6504 9.95579 14.6504 10.9698C14.6504 11.9838 15.4724 12.8058 16.4864 12.8058Z",
    fill: "#3D3B3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97466 17.9776C5.98865 17.9776 6.81065 17.1556 6.81065 16.1417C6.81065 15.1277 5.98865 14.3057 4.97466 14.3057C3.96067 14.3057 3.13867 15.1277 3.13867 16.1417C3.13867 17.1556 3.96067 17.9776 4.97466 17.9776Z",
    fill: "#3D3B3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7305 17.9776C11.7445 17.9776 12.5665 17.1556 12.5665 16.1417C12.5665 15.1277 11.7445 14.3057 10.7305 14.3057C9.71653 14.3057 8.89453 15.1277 8.89453 16.1417C8.89453 17.1556 9.71653 17.9776 10.7305 17.9776Z",
    fill: "#3D3B3B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4864 17.9776C17.5004 17.9776 18.3224 17.1556 18.3224 16.1417C18.3224 15.1277 17.5004 14.3057 16.4864 14.3057C15.4724 14.3057 14.6504 15.1277 14.6504 16.1417C14.6504 17.1556 15.4724 17.9776 16.4864 17.9776Z",
    fill: "#3D3B3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerSmall);
export default __webpack_public_path__ + "static/media/date_picker_small.4c5034e2acccbf056faf4b5c339c1722.svg";
export { ForwardRef as ReactComponent };